import _get from './get';
import _post from './post';

const QAManager = {
	_get,
	_post
};

export default QAManager;
